export enum ScopeThreeCategoryStatusEnums {
  COMPLETED = 'Completed',
  IN_COMPLETE = 'Incomplete',
  COMING_SOON = 'Coming Soon',
}

export enum ActivityDataEntryScopeTabs {
  SCOPE_1 = 'scope1',
  SCOPE_2 = 'scope2',
  SCOPE_3_UPSTREAM = 'scope3Upstream',
  SCOPE_3_DOWNSTREAM = 'scope3Downstream',
  PRODUCTION_DATA = 'productionData',
}
